// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3of_O","col":"styles_col__WPb-l"};